module.exports = __webpack_public_path__ + "img/h10.fa473ffc.png";